import * as Yup from 'yup';
import { stringRequired, validPassword } from './schemas.global';

export const newPasswordSchema = Yup.object({
    password: validPassword,
    passwordConfirm: stringRequired
        .oneOf([Yup.ref('password'), null], 'Las contraseñas no coinciden')
})

export type NewPasswordSchemaType = Yup.InferType<typeof newPasswordSchema>;